// extracted by mini-css-extract-plugin
export default {"content":"y6Qn8","dropzone":"_MkRc","checkboxContainer":"CoMvf","checkbox":"EybOr","options":"zefYw"};